import React from "react";
import { gsap } from "gsap";

export function contractLogoAnim() {
  gsap.set(".contract_animation_container svg", { opacity: 1 });

  const repeatedSine = { repeat: -1, yoyo: true, ease: "sine.inOut" };

  gsap.set("#g2o1, #g2m1", { opacity: 0 });

  //REPEATED
  gsap.to("#g2", { y: -30, duration: 1, ...repeatedSine, delay: -3 });

  const g2 = gsap
    .timeline({ defaults: { duration: 0.7 } })
    .to("#g2o1", { opacity: 1 })
    .to("#g2m1", { opacity: 1 });
}

export default function AnimatedContract() {
  const contractAnimationContainer = {
    display: "flex",
    margin: "0 auto",
    height: "100px",
    width: "100px",
    alignItems: "center",
    justifyContent: "center",
  };

  const contract_animation_container_svg = {
    width: "100%",
    height: "100%",
    opacity: "0",
  };

  React.useEffect(() => {
    contractLogoAnim();
  }, []);

  return (
    <div
      style={contractAnimationContainer}
      className="contract_animation_container"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 1602.57 2646.48"
        style={contract_animation_container_svg}
      >
        <defs>
          <linearGradient
            id="Градієнт_без_назви_4"
            data-name="Градієнт без назви 4"
            x1="859.77"
            y1="2364.69"
            x2="789.46"
            y2="-29.65"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#d1c5f6" />
            <stop offset="0.02" stopColor="#d3c8f6" stopOpacity="0.95" />
            <stop offset="0.13" stopColor="#ddd5f8" stopOpacity="0.73" />
            <stop offset="0.25" stopColor="#e6e0fa" stopOpacity="0.53" />
            <stop offset="0.36" stopColor="#eeeafc" stopOpacity="0.37" />
            <stop offset="0.48" stopColor="#f4f1fd" stopOpacity="0.24" />
            <stop offset="0.6" stopColor="#f9f7fe" stopOpacity="0.13" />
            <stop offset="0.72" stopColor="#fcfcfe" stopOpacity="0.06" />
            <stop offset="0.85" stopColor="#fefeff" stopOpacity="0.01" />
            <stop offset="1" stopColor="#fff" stopOpacity="0" />
          </linearGradient>
        </defs>
        <g id="g2">
          <path
            d="M196.88,1747.56l637.5-366.38,713,417.25c60.29,35.28,60.22,122.45-.13,157.63L1011,2268.64a228.84,228.84,0,0,1-229.61.51L196.72,1931.78C125.76,1890.83,125.85,1788.38,196.88,1747.56Z"
            fill="#84b0d1"
          />
          <path
            d="M196.88,1696.16,708.3,1402.24a250.74,250.74,0,0,1,251.58,1L1547.41,1747c60.29,35.28,60.22,122.45-.13,157.63L1011,2217.24a228.82,228.82,0,0,1-229.61.51L196.72,1880.38C125.76,1839.44,125.85,1737,196.88,1696.16Z"
            fill="#bce6e3"
          />
          <g id="g2m1">
            <polygon
              points="1135.12 1769.37 438.9 1873.8 438.9 677.31 1135.12 576.83 1135.12 1769.37"
              fill="#ccc"
            />
            <polygon
              points="1142.33 1772.97 446.11 1877.41 446.11 680.92 1142.33 580.44 1142.33 1772.97"
              fill="#c6c1c1"
            />
            <polygon
              points="1149.39 1776.58 453.18 1881.01 453.18 684.52 1149.39 584.04 1149.39 1776.58"
              fill="#d8d2d2"
            />
            <polygon
              points="1163.09 1789.56 466.88 1893.99 466.88 697.5 1163.09 597.02 1163.09 1789.56"
              fill="#dbd9d9"
            />
            <polygon
              points="1153.72 1785.23 457.51 1889.66 457.51 693.17 1153.72 592.7 1153.72 1785.23"
              fill="#fff"
            />
            <polygon
              points="1090.2 730.79 539.77 809.58 539.77 730.79 1090.2 652.01 1090.2 730.79"
              fill="#e6bcd4"
            />
            <g>
              <path d="M645.05,905.25c-2.78,1.92-8.54,4.28-16.21,5.39-17.75,2.55-32.73-6.74-35.7-27.4-2.84-19.72,8.61-35,28.14-37.82,7.85-1.12,13-.15,15.36.66l-1,6.91a30.33,30.33,0,0,0-13.09-.79c-14.77,2.13-23.22,13-20.84,29.52,2.21,15.43,12.52,24,27.84,21.85a32.8,32.8,0,0,0,12.9-4.53Z" />
              <path d="M705,866c3.12,21.68-8.4,35.08-24.48,37.38-16.63,2.4-30.17-8.82-32.91-27.89-2.88-20,7.67-34.86,24.49-37.29C689.33,835.68,702.34,847.26,705,866ZM656.3,874c1.94,13.46,11,24.47,23.76,22.62s18.48-14.76,16.43-29.06c-1.8-12.53-10.23-24.68-23.78-22.73S654.31,860.18,656.3,874Z" />
              <path d="M722.57,896.29l-9.06-63,8.88-1.28,24.77,29a179.41,179.41,0,0,1,14.25,18.85l.18-.13c-2-8.3-3.25-15.93-4.66-25.74l-3.79-26.36,7.66-1.1,9.06,63-8.22,1.18L737,861.59a202.07,202.07,0,0,1-14.8-19.34l-.27.13c1.61,7.88,2.89,15.43,4.4,25.89l3.87,26.92Z" />
              <path d="M790.56,829.3l-19.16,2.76-1-6.91L817,818.44l1,6.91-19.25,2.78,8.07,56.07-8.23,1.18Z" />
              <path d="M826.52,818a85.13,85.13,0,0,1,15.42-3.56c8.69-1.25,14.53-.46,19,2.52a15.89,15.89,0,0,1,6.67,11.26c1.19,8.31-3.25,14.58-9.56,17.78l0,.27c5.1,1,8.64,5,11.08,11.38,3.32,8.49,5.69,14.35,7.35,16.59l-8.42,1.21c-1.28-1.63-3.46-6.84-6.37-14.44-3.11-8.42-7-11.2-14.37-10.42l-7.67,1.1L843.59,879l-8.13,1.16Zm12.26,27.52,8.31-1.2c8.69-1.25,13.52-6.8,12.49-14-1.17-8.14-7.57-10.84-16.18-9.69a33.59,33.59,0,0,0-7.93,1.9Z" />
              <path d="M895.82,851.25,892.13,872l-8.42,1.21,12.35-66.07,9.81-1.4,30.55,59.89-8.69,1.25L918.16,848Zm19.74-9.33-8.78-17.25c-2-3.9-3.46-7.5-4.92-11l-.19,0c-.4,3.88-.87,7.85-1.54,11.86l-3.54,19.12Z" />
              <path d="M990.25,855.84c-2.77,1.93-8.54,4.28-16.2,5.39-17.76,2.55-32.74-6.74-35.71-27.4-2.84-19.72,8.61-35,28.14-37.81,7.85-1.13,13-.16,15.36.65l-1,6.92a30,30,0,0,0-13.09-.79c-14.76,2.13-23.22,13-20.84,29.51,2.21,15.43,12.52,24.05,27.84,21.85a32.8,32.8,0,0,0,12.9-4.53Z" />
              <path d="M1009.78,797.93l-19.15,2.76-1-6.92,46.63-6.7,1,6.91L1018,796.75l8.06,56.08-8.22,1.18Z" />
            </g>
            <path
              d="M569.21,978,1060.76,907M569.21,1013.45l491.55-70.94m0,35.47-491.55,71m0,35.47,491.55-71M569.21,1119.87l491.55-70.94M569.21,1155.34l491.55-70.94M569.21,1190.81l491.55-70.94m0,35.47-491.55,70.94m0,35.48,491.55-71M569.21,1297.23l491.55-71M569.21,1332.7l491.55-70.94M569.21,1368.17l491.55-70.94M569.21,1403.64l491.55-70.94M569.21,1439.11l491.55-70.94M569.21,1474.59l491.55-70.95M569.21,1510.06l491.55-71m0,35.48-491.55,70.94m491.55-35.47L569.21,1581m0,35.47,491.55-70.94M569.21,1651.94,1060.76,1581M569.21,1687.42l491.55-71M569.21,1722.89l491.55-71M569.21,1758.36l491.55-70.94"
              fill="none"
              stroke="#000"
              strokeMiterlimit="10"
            />
            <g>
              <polygon
                points="814.96 1174.56 812.88 1181.62 812.88 1386.39 814.96 1388.47 910.01 1332.28 814.96 1174.56"
                fill="#343434"
              />
              <polygon
                points="814.96 1174.56 719.9 1332.28 814.96 1388.47 814.96 1289.07 814.96 1174.56"
                fill="#8c8c8c"
              />
              <polygon
                points="814.96 1406.46 813.79 1407.89 813.79 1480.84 814.96 1484.26 910.07 1350.31 814.96 1406.46"
                fill="#3c3c3b"
              />
              <polygon
                points="814.96 1484.26 814.96 1406.46 719.9 1350.31 814.96 1484.26"
                fill="#8c8c8c"
              />
              <polygon
                points="814.96 1388.47 910.01 1332.28 814.96 1289.07 814.96 1388.47"
                fill="#141414"
              />
              <polygon
                points="719.9 1332.28 814.96 1388.47 814.96 1289.07 719.9 1332.28"
                fill="#393939"
              />
            </g>
          </g>
          <path
            id="g2o1"
            d="M13.94,399.48,132.48,1721.27c6,50.74,25.59,100.18,61.75,134.32l3.28,3.1a9.07,9.07,0,0,0,1.57,1.2l595.75,356.4c69.86,42.36,156,41.92,225.43-1.17l510.29-318.33a94.8,94.8,0,0,0,36-40.93h0c2.41-5.21,4.93-10.38,7.71-15.38,20.63-37,11.17-70.85,16-115.94L1588.63,346.7"
            fill="url(#Градієнт_без_назви_4)"
          />
        </g>
      </svg>
    </div>
  );
}
